import React from 'react';
import { creations } from '../data/creations';
export function CreationsGallery() {
  return <section aria-labelledby="creations-title" className="bg-cream px-5 sm:px-8 py-16 sm:py-24" data-id="element-50" data-mp="lbu4bgr2aqp4">
      <div className="max-w-6xl mx-auto" data-id="element-51" data-mp="gczevvyla3w1">
        <div className="max-w-2xl mx-auto text-center" data-id="element-52" data-mp="gbo6tjy429z4">
          <p className="text-xs font-semibold tracking-[0.12em] text-berry-deep" data-id="element-53" data-mp="cc71qrmljeuh">
            IDEE DA CREARE
          </p>
          <h2 id="creations-title" className="mt-3 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum text-balance" data-id="element-54" data-mp="7dmahhpbo5i6">
            Immagina cosa puoi creare{' '}
            <span className="italic font-medium text-berry-deep" data-id="element-55" data-mp="3trdu25sixqzf">con il tricotin</span>.
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-56" data-mp="3otu5od243xtr">
            Nomi, iniziali, fiori e piccoli dettagli: lasciati ispirare da forme e colori da reinterpretare con il tuo stile.
          </p>
        </div>

        <ul className="mt-10 sm:mt-14 grid grid-cols-2 gap-x-3 gap-y-6 sm:gap-x-6 sm:gap-y-8 lg:grid-cols-3" data-id="element-57" data-mp="3fsw7ibecukj3">
          {creations.map(c => <li key={c.id} data-id="element-58" data-mp="1yciuluh9u3py">
              <figure data-id="element-59" data-mp="1ycsmxopsgmyt">
                <div className="aspect-[4/5] overflow-hidden rounded-[18px] bg-blush shadow-soft" data-id="element-60" data-mp="1ydaqz7ip05ha">
                  <img src={c.src} alt={c.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-61" data-mp="1kmfc9eliiu5s" />
                </div>
                <figcaption className="mt-3 text-center font-serif italic text-base sm:text-lg text-plum" data-id="element-62" data-mp="1okd8309sgei5">
                  {c.motif}
                </figcaption>
              </figure>
            </li>)}
        </ul>

        
      </div>
    </section>;
}